/*
  td-lp: LGXNDS landing pages. Buy buttons add to cart and open the Upcart drawer (same as the
  Replo pages did); thumbnails swap the main product image.
*/
(function () {
  if (window.tdLpReady) return;
  window.tdLpReady = true;

  document.addEventListener('click', function (event) {
    var buy = event.target.closest('[data-td-lp-add]');
    if (buy) {
      event.preventDefault();
      if (buy.disabled) return;
      buy.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(buy.dataset.tdLpAdd), quantity: Number(buy.dataset.tdLpQty) || 1 }] }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
          if (typeof window.upcartOpenCart === 'function') {
            window.upcartOpenCart();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          window.location.href = buy.dataset.tdLpFallback || '/cart';
        })
        .finally(function () {
          buy.disabled = false;
        });
      return;
    }

    var thumb = event.target.closest('[data-td-lp-thumb]');
    if (thumb) {
      var media = thumb.closest('.td-lp-product__media');
      var main = media && media.querySelector('.td-lp-product__main img');
      var img = thumb.querySelector('img');
      if (!main || !img) return;
      main.src = img.dataset.full || img.src;
      main.removeAttribute('srcset');
      media.querySelectorAll('[data-td-lp-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    }
  });
})();
